export default "__VITE_ASSET__BaM$iXcY__"